import { createFileRoute } from "@tanstack/react-router"
import { validateReportsSearch } from "@/features/operations/operations-search"
import { ReportsPage } from "@/features/operations/reports-page"
export const Route = createFileRoute("/_authenticated/reports")({
    validateSearch: validateReportsSearch,
    component: ReportsPage,
})
